module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "offset-md1": "",
      "md5": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-green no-transform",
    attrs: {
      "round": "",
      "large": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.itemEscolha('')
      }
    }
  }, [_c('span', {
    staticClass: "pr-1"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add_circle_outline")])], 1), _vm._v("\n      Novo item\n    ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md5": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-blue no-transform",
    attrs: {
      "round": "",
      "large": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filterActive(2)
      }
    }
  }, [_vm._v("\n      Todos\n    ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-green no-transform",
    attrs: {
      "round": "",
      "large": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filterActive(1)
      }
    }
  }, [_vm._v("\n      Ativos\n    ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-red no-transform",
    attrs: {
      "round": "",
      "large": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filterActive(0)
      }
    }
  }, [_vm._v("\n      Inativos\n    ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "searchInput",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md3": "",
      "label": "Pesquisar itens",
      "append-icon": "search"
    },
    model: {
      value: (_vm.searchItem),
      callback: function($$v) {
        _vm.searchItem = $$v
      },
      expression: "searchItem"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "offset-md1": "",
      "md10": ""
    }
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "pa-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.filteredItens), function(item) {
    return _c('v-flex', {
      key: item.id,
      attrs: {
        "xs12": "",
        "sm6": "",
        "md4": ""
      }
    }, [_c('ItemCard', {
      attrs: {
        "value": item
      }
    })], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-flex', [_c('ItemDetalhes')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41c5ad4b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/itens/relacao.vue
// module id = 748
// module chunks = 2